import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import useApiManager from '../../utils/Api/apiManager';
import { useNavigate, Link } from "react-router-dom";
import { LeadSource } from '../../utils/enums'

const NotesGlobalSearch = ({ globalSearchValue }) => {
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [sortModel, setSortModel] = useState([]);
    const navigate = useNavigate();
    const { post } = useApiManager();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 50,
    });

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5 },
        {
            field: 'title',
            headerName: 'Title',
            flex: 1,
            renderCell: (params) => {
                const displayName = params.value?.trim() || "(N/A)";

                const getLinkByEntityType = (row) => {
                    switch (row.entityType) {
                        case 0:
                            return `/leads/${row.leadId}`;
                        case 1:
                            return `/contacts/${row.leadId}`;
                        case 2:
                            return `/accounts/${row.accountId}`;
                        case 3:
                            return `/campaigns/${row.campaignId}`;
                        case 4:
                            return `/deals/${row.dealId}`;
                        default:
                            return '#'; // fallback link
                    }
                };

                return (
                    <Link
                        to={getLinkByEntityType(params.row)}
                        onClick={(e) => e.stopPropagation()}
                        style={{ color: 'inherit' }}
                    >
                        {displayName}
                    </Link>
                );
            },
        },
        { field: 'content', headerName: 'Content', flex: 1 },
        { field: 'entityType', headerName: 'Entity Type', flex: 1 },
        { field: 'leadId' },
        { field: 'accountId' },
        { field: 'campaignId' },
        { field: 'dealId' }
    ];

    const transformData = (data) => {
        return data.map(item => ({
            id: item.id,
            title: item.title,
            content: item.content,
            entityType: item.entityType,
            leadId: item.leadId,
            accountId: item.accountId,
            campaignId: item.campaignId,
            dealId: item.dealId
        }));
    };

    useEffect(() => {
        const fetchAndSetData = async () => {
            setLoading(true);
            try {
                const operatorMapping = {
                    "contains": 2,
                    "equals": 0,
                    "starts with": 4,
                    "ends with": 5,
                    "is empty": 6,
                    "is not empty": 7,
                    // "is any of": Not directly mapped
                };



                const sortField = sortModel.length > 0 ? sortModel[0].field : 'content'; // Default to 'firstName'
                const sortDescending = sortModel.length > 0 ? sortModel[0].sort === 'desc' : false;

                let url = "/notes/paged/globalsearch";

                const data = await post(url, {
                    pageNumber: paginationModel.page + 1,
                    pageSize: paginationModel.pageSize,
                    sortField: sortField,
                    sortDescending: sortDescending,
                    globalSearchValue: globalSearchValue
                });
                setRows(transformData(data.items));
                setRowCount(data.totalCount);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAndSetData();
    }, [paginationModel, sortModel]);

    const handleRowClick = (params) => {
        if (params.row.entityType == 0) {

            navigate(`/leads/${params.row.leadId}`);
        }
        else if (params.row.entityType == 1) {
            navigate(`/contacts/${params.row.leadId}`);
        }
        else if (params.row.entityType == 2) {
            navigate(`/accounts/${params.row.accountId}`);
        }
        else if (params.row.entityType == 3) {
            navigate(`/campaigns/${params.row.campaignId}`);
        }
        else if (params.row.entityType == 4) {
            navigate(`/deals/${params.row.dealId}`);
        }

    };

    return (
        <DataGrid
            rows={rows}
            columns={columns}
            rowCount={rowCount}
            paginationMode="server"
            sortingMode="server"
            columnVisibilityModel={{
                id: false,
                entityType: false,
                leadId: false,
                accountId: false,
                campaignId: false,
                dealId: false
            }}
            getRowId={(row) => row.id}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[50, 75, 100]}
            onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            filterMode="server"
            checkboxSelection
            disableRowSelectionOnClick
            loading={loading}
            onRowClick={handleRowClick}
            sx={{
                maxHeight: '500px',
                overflow: 'auto',
                minHeight: 200,
                height: '100%', // Fills the parent container
                '& .MuiDataGrid-virtualScroller': {
                    overflow: 'auto', // Ensures scrollbars appear when necessary
                },
            }}
        />
    );
};

export default NotesGlobalSearch;
